export const PATIENTS_PATH = "/patients";

export const DASHBOARD_PATH = "/dashboard";

export const SEARCH_SUGGESTIONS = 5;

export const SEARCH_MIN_TERM = 2;

export const WEBSITE_PAGE_PATH = "/settings?view=website";

export const WEBSITE_EDITOR_PATH = "/website/edit";
